import { isValkTalkEnabled } from './featureFlags'

interface StreamUserLike {
    streamUserId?: string | null
}

/**
 * Whether the user is meant to see/use the Stream-based (ValkTalk) social features
 */
export const hasStreamAccess = (user?: StreamUserLike | null): boolean => isValkTalkEnabled() && !! user?.streamUserId
